import onetime from "@-/com.npmjs.onetime";
import generalStandardChineseCharacterTable from "@-/com.npmjs.table-of-general-standard-chinese-characters";

export type GraphemeTier = 1 | 2 | 3;

/** Official PRC standard-character graphemes grouped by tier. */
export const getGraphemesByTier = onetime(() => ({
  tier1: generalStandardChineseCharacterTable.tier1 satisfies string[],
  tier2: generalStandardChineseCharacterTable.tier2 satisfies string[],
  tier3: generalStandardChineseCharacterTable.tier3 satisfies string[],
}));

/** PRC 通用规范汉字表 tier (1–3) keyed by grapheme. */
export const getTierByGraphemeDict = onetime((): Readonly<Record<string, GraphemeTier>> =>
  Object.freeze(
    Object.fromEntries([
      ...generalStandardChineseCharacterTable.tier1.map(
        (grapheme): readonly [string, GraphemeTier] => [grapheme, 1],
      ),
      ...generalStandardChineseCharacterTable.tier2.map(
        (grapheme): readonly [string, GraphemeTier] => [grapheme, 2],
      ),
      ...generalStandardChineseCharacterTable.tier3.map(
        (grapheme): readonly [string, GraphemeTier] => [grapheme, 3],
      ),
    ]),
  ),
);
